// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"8a306865","231":"2416cd46"}[chunkId] + ".chunk.js";
};